// @ts-nocheck
import React, { useState } from "react";

import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuIcon from "@mui/icons-material/Menu";
import { deepOrange } from "@mui/material/colors";

import {
  Box,
  MenuItem,
  Link,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
  Tooltip,
  Typography,
  Grid,
  Avatar,
  Menu,
} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import image_url from "../../assets/images/image_url";
import useWindowSize from "../../common/hooks/window-size.tsx";
import Colors from "../../utility/Colors";
import Backdrop from "../backdrop/index.tsx";
import "./index.module.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import InboxIcon from "@mui/icons-material/Inbox";
import MailIcon from "@mui/icons-material/Mail";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import SegmentIcon from "@mui/icons-material/Segment";
import WorkIcon from "@mui/icons-material/Work";
import BusinessIcon from "@mui/icons-material/Business";
import GroupIcon from "@mui/icons-material/Group";
import NoteIcon from "@mui/icons-material/Note";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import {
  clearSession,
  clearSessionKey,
  getLoginDetails,
  getRefreshToken,
  getUserDetails,
} from "../../utility/SessionManager.js";
import Methods, { decrypt, handleLogOut } from "../../utility/Methods.js";
import LanIcon from "@mui/icons-material/Lan";
import BadgeIcon from "@mui/icons-material/Badge";
import BugReportIcon from "@mui/icons-material/BugReport";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import constants from "../../common/constants.js";
import { background_orange_gradient } from "../../assets/jss/material.js";
import SppaarkLogo from "../../assets/images/SppaarkLogo.webp";
// import { Flex } from "antd";
import PersonIcon from "@mui/icons-material/Person";
const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  margin: "0px",
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  [theme.breakpoints.down(700)]: {
    display: "flex",
  },
  [theme.breakpoints.up(700)]: {
    display: "flex",
    // mt: 4,
    // mb: 4,
  },
}));

const StyledAppbar = styled(AppBar)(({ theme }) => ({
  position: "relative",
  display: "block",
  paddingRight: "0px !important",
  zIndex: theme.zIndex.drawer + 1,
}));

const ArrayMenu = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    path: "dashboard",
  },

  {
    title: "Users",
    icon: <GroupIcon />,
    path: "users",
  },

  {
    title: "Log Out",
    icon: <LogoutIcon />,
    path: "/login",
  },
];

const ArrayMenuForUser = [
  {
    title: "Dashboard",
    icon: <DashboardIcon />,
    path: "dashboard",
  },
  {
    title: "Profile",
    icon: <GroupIcon />,
    path: "profile",
  },
  {
    title: "Log Out",
    icon: <LogoutIcon />,
    path: "/login",
  },
];
const Header = (props) => {
  const navigate = useNavigate();
  const role = Methods.getRole();
  let allowedRolesForAddReward = [
    constants.CASE_OWNER,
    constants.HOD,
    constants.LEGAL_MANAGER,
    constants.CHECKER,
  ];
  const emailId = Methods.getEmail();
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const drawerWidth = 240;
  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  }));
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleNav = (path) => {
    navigate(path);
    setOpen(false);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  let sideMenu = role === constants.USER ? ArrayMenuForUser : ArrayMenu;

  const MenuItemsForTopAppbar = () => {
    return (
      <>
        {/* <StyledMenuItem
          sx={(theme) => {
            return {
              [theme.breakpoints.down(725)]: {
                display: "none",
              },
            };
          }}
        >
          <StyledLink href="tel:1800-102-4465">
            To Renew :<FontAwesomeIcon icon={faPhone} style={{}} />
            1800 102 4465
          </StyledLink>
        </StyledMenuItem>
        <StyledMenuItem
          sx={(theme) => {
            return {
              [theme.breakpoints.down(725)]: {
                display: "none",
              },
            };
          }}
        >
          <StyledLink href="tel:1800-102-4462">
            For Service :<FontAwesomeIcon icon={faPhone} style={{}} />
            1800 102 4462
          </StyledLink>
        </StyledMenuItem>
        <StyledMenuItem
          sx={(theme) => {
            return {
              [theme.breakpoints.down(725)]: {
                display: "none",
              },
            };
          }}
        >
          <StyledLink href="tel:1800-102-4464">
            To Buy :<FontAwesomeIcon icon={faPhone} style={{}} />
            1800 102 4464
          </StyledLink>
        </StyledMenuItem> */}

        <StyledMenuItem>
          <StyledLink href="">
            {pathname.toLowerCase() === "/landing-page" && (
              <Tooltip title="Login">
                <Typography
                  size="medium"
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    // padding: "12px",
                    p: 1,
                    borderRadius: "30px",
                    "&:hover": { opacity: 0.9 },
                  }}
                  onClick={() => navigate("/login")}
                >
                  Login
                </Typography>
              </Tooltip>
            )}
            {/* <FontAwesomeIcon icon={faBell} style={{}} /> */}
          </StyledLink>
        </StyledMenuItem>
      </>
    );
  };

  const LogOut = () => {
    handleLogOut(dispatch, navigate);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navigate("/profile");
    handleMenuClose();
  };

  const handleLogoutClick = () => {
    // LogOut();

    handleLogOut(dispatch, navigate);
    handleMenuClose();
  };

  return (
    <>
      <Box
        sx={{
          top: 0,
          left: 0,
          width: "100%",
          background: "#f5841f",
        }}
      >
        <StyledAppbar
          sx={{
            backgroundColor: "#f5841f",
            zIndex: 1200,
          }}
        >
          <Box>
            <Box
              sx={{
                float: "right",
              }}
            >
              <MenuItemsForTopAppbar />
            </Box>
          </Box>
          <StyledAppbar
            sx={{
              minHeight: "50px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#fff",
              borderTop: "5px solid #0284c9",
              borderRadius: "12px 12px 0 0",
              zIndex: 1201,
              fontFamily: "Arimo, sans-serif",
            }}
          >
            <div style={{ display: "flex", height: "63px" }}>
              {/* {pathname.toLowerCase() !== "/login" &&
                pathname.toLowerCase() !== "/landing-page" && (
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                    sx={[
                      {
                        m: 0,
                      },
                      open && { display: "none" },
                    ]}
                  >
                    <MenuIcon sx={{ color: Colors.BLACK }} />
                  </IconButton>
                )} */}
              {!open && (
                <Box sx={{ p: 1 }}>
                  {Cookies.get("manipalcigna_user_token") ? (
                    <Link
                      onClick={() => navigate("/dashboard")}
                      sx={{ cursor: "pointer" }}
                    >
                      <img
                        src={
                          image_url.IMG_MCHI_LOGO_LOCAL || "/placeholder.svg"
                        }
                        style={{
                          width: "13vw",
                          marginLeft: "10%",
                        }}
                      />
                    </Link>
                  ) : (
                    <Link href="/abha">
                      <img
                        src={
                          image_url.IMG_MCHI_LOGO_LOCAL || "/placeholder.svg"
                        }
                        style={{
                          width: "13vw",
                          marginLeft: "10%",
                        }}
                      />
                      {/* <img
                        src={image_url.IMG_MCHI_LOGO_LOCAL || "/placeholder.svg"}
                        style={{ width: "13vw" }}
                      /> */}
                    </Link>
                  )}
                </Box>
              )}
            </div>
            <div style={{ display: "flex" }}>
              {!open && (
                <Box>
                  {/* {Cookies.get("manipalcigna_user_token") ? (
                    <Link
                      onClick={() => navigate("/dashboard")}
                      sx={{ cursor: "pointer" }}
                    >
                      <img
                        src={image_url.IMG_MCHI_LOGO_LOCAL || "/placeholder.svg"}
                        style={{ width: "65%" }}
                      />
                    </Link>
                  ) : (
                    <Link href="/mchi-connect/login">
                      <img
                        src={image_url.IMG_MCHI_LOGO_LOCAL || "/placeholder.svg"}
                        style={{ width: "65%" }}
                      />
                    </Link>
                  )} */}
                </Box>
              )}
              {console.log("")}
              {pathname.toLowerCase() != "/login" &&
                pathname.toLowerCase() != "/landing-page" && (
                  <>
                    {/* <StyledMenuItem
                      sx={{
                        textAlign: "center",
                        "&:hover": {
                          backgroundColor: "transparent", // Or any color you want
                        },
                      }}
                    >
                      <StyledLink href="">
                        <Typography
                          onClick={() => {
                            navigate("/dashboard");
                          }}
                        >
                          Home
                        </Typography>
                      </StyledLink>
                    </StyledMenuItem> */}

                    <StyledMenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      <Tooltip title="Account">
                        <Avatar
                          fontSize="medium"
                          sx={{
                            bgcolor: deepOrange[500],
                            cursor: "pointer",
                          }}
                          onClick={handleAvatarClick}
                        >
                          {emailId?.slice(0, 2).toUpperCase()}
                        </Avatar>
                      </Tooltip>
                    </StyledMenuItem>
                  </>
                )}
            </div>

            {/* <StyledMenuItem>
              <StyledLink href="">
                <FontAwesomeIcon icon={faBell} style={{}} />
              </StyledLink>
            </StyledMenuItem> */}
          </StyledAppbar>
        </StyledAppbar>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {/* <MenuItem onClick={handleProfileClick}>
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            Profile
          </MenuItem> */}
          <MenuItem onClick={handleLogoutClick}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          anchor="left"
          open={open}
          onClose={toggleDrawer(false)}
        >
          <DrawerHeader>
            <Link
              onClick={() => navigate("/dashboard")}
              sx={{ cursor: "pointer" }}
            >
              <img
                src={image_url.IMG_MCHI_LOGO_LOCAL || "/placeholder.svg"}
                style={{ width: "13vw" }}
              />
            </Link>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {sideMenu?.map((objItem) => (
              <ListItem key={objItem.title} disablePadding>
                <ListItemButton
                  key={objItem.path}
                  onClick={
                    objItem.title == "Log Out"
                      ? () => {
                          setOpen(false);
                          handleLogOut(dispatch, navigate);
                        }
                      : () => handleNav(objItem.path)
                  }
                >
                  <ListItemIcon>{objItem.icon}</ListItemIcon>
                  <ListItemText primary={objItem.title} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </Box>
    </>
  );
};

export default Header;
